var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"in-flag__item",style:({ backgroundColor: _vm.flag.rgbColor })},[_vm._v(" "+_vm._s(_vm.flag.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }